export enum ScaleUnit {
    MINUTE = "minute",
    HOUR = "hour",
    DAY = "day",
}
